<div class="layout-auto-1">
  <div></div>
  <div class="content md3-surface">
    <div class="layout-list-quickfilter md3-card-on-surface">
      <!-- Search Header -->
      <exg-search-bar (Search)="scheduleTable.search($event)" [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="scheduleTable.loadData()" class="search-action fal fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-filter"
                 [class.fas]="scheduleTable.uiFilterAktiv(1).length > 0"
                 [class.fal]="scheduleTable.uiFilterAktiv(1).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCscheduleTableFilterControl
                              (onActivateFilter)="scheduleTable.pageChanged(1);popup.close()"
                              [MetaInfo]="scheduleTable.MetaInfo"
                              [showFilter]="true" [uiFilter]="scheduleTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="scheduleTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-sort-alt"
                 [class.fas]="scheduleTable.uiSortAktiv().length > 0"
                 [class.fal]="scheduleTable.uiSortAktiv().length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCscheduleTableSortControl
                              (onActivateFilter)="scheduleTable.pageChanged(1);popup.close()"
                              [MetaInfo]="scheduleTable.MetaInfo"
                              [showSort]="true" [uiFilter]="scheduleTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="scheduleTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-binoculars"
                 [class.fas]="scheduleTable.uiFilterAktiv(2).length > 0"
                 [class.fal]="scheduleTable.uiFilterAktiv(2).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCscheduleTableSearchControl
                              (onActivateFilter)="scheduleTable.pageChanged(1);popup.close()"
                              [MetaInfo]="scheduleTable.MetaInfo"
                              [showSearch]="true" [uiFilter]="scheduleTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="scheduleTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i class="search-action far fa-gears"
             [class.disabled]="!scheduleTable.newV2Table"
             (click)="openTableSettings($event)">
          </i>
          <exg-table-settings #tableDefinitionSettings
                              [tableDef]="scheduleTable.tableDefinition"
                              [metaInfo]="scheduleTable.MetaInfo"
                              localStorageID="scheduleTable">
          </exg-table-settings>
          <i class="search-action fa-table"
             (click)="scheduleTable.newV2Table = !scheduleTable.newV2Table;"
             [class.fas]="scheduleTable.newV2Table"
             [class.fal]="!scheduleTable.newV2Table">
          </i>
        </ng-template>
      </exg-search-bar>
      <div class="content">
        <ng-container *ngIf="!scheduleTable.newV2Table">
          <exg-data-table #VCscheduleTable (ItemSelect)="scheduleTable.selectedRow"

                        (RowChange)="scheduleTable.selectionChanged($event)" [allowSingleSelection]="true"
                        [displayState]="scheduleTable.state"
                        [rowSource]="scheduleTable.data"
                        containerClass="grid cols-19"
                        [selectKey]="scheduleTable.selectKey"
                        (RowDblClick)="scheduleTable.dblClick($event)">
          <ng-template #headerTemplate>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgNr')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgVorgangTyp')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorg_oid_Bearbeiter')}}</strong></p>
              <p><strong>{{getRessource('TableRenames.lastSV')}} ({{enumSvc.getFieldCaption('Vorgang', 'BearbeiterCo')}})</strong></p>
            </div>
            <div class="span-3">
              <p><strong>{{enumSvc.getFieldCaption('Ablaufplan', 'apiBezeichnung')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('Ablaufplan', 'apiKommentar')}}</strong></p>
            </div>
            <div class="">
              <p><strong>{{enumSvc.getFieldCaption('Ablaufplan', 'apiSollDatum')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('Ablaufplan', 'apiPlanDatum')}}</strong></p>
            </div>
            <div class="">
              <p><strong>{{enumSvc.getFieldCaption('Ablaufplan', 'apiIstDatum')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{getRessource('TableRenames.CaseStatus')}}</strong></p>
              <p><strong>{{getRessource('TableRenames.TaskStatus')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('All', '%CKU')}}</strong></p>
              <p><strong>{{getRessource('TableRenames.CheckedDate')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption("All", "%LCU")}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption("All", "%LCD")}}</strong></p>
            </div>
          </ng-template>
          <ng-template #rowTemplate let-row>
            <div class="span-2 app-scheduleitem">
              <p>{{row.api_OidNr}}</p>
              <p>{{row.aueSchadenNr}}</p>
            </div>
            <div class="span-2 app-scheduleitem" [class.escalated]="row.apiIsEscalated">
              <p>{{enumSvc.getEnumerationText(row.au_enmName_AuftragTyp, row.au_enmIdent_AuftragTyp)}}</p>
              <p>
                <ng-container *ngIf="row.api_OidTyp === 'Vorgang'">{{enumSvc.getEnumerationText(
                  row.vorg_enmName_VorgangTyp, row.vorg_enmIdent_VorgangTyp)}}</ng-container>
                <ng-container *ngIf="row.api_OidTyp === 'Auftrag'">-</ng-container>
              </p>
            </div>
            <div class="span-2 app-scheduleitem" [class.escalated]="row.apiIsEscalated">
              <p>{{row.vorgBearbeiter  || '-'}}</p>
              <p>{{row.aueLetzterSachverstaendiger ? row.aueLetzterSachverstaendiger : ''}}{{row.BearbeiterCo === row.aueLetzterSachverstaendiger && !!row.BearbeiterCo ? '* (Beides)' : ' '}}{{row.BearbeiterCo && row.BearbeiterCo !== row.aueLetzterSachverstaendiger ? '(' + row.BearbeiterCo + ')' : ''}}</p>
            </div>
            <div class="span-3">
              <p>{{row.apiBezeichnung || '-'}}</p>
              <p>{{row.apiKommentar || '-'}}</p>
            </div>
            <div class="app-scheduleitem" [class.escalated]="row.apiIsEscalated">
              <p>{{row.apiSollDatum | excDate:'Globals.DateFormat' }}</p>
              <p>
                <ng-container
                  *ngIf="row.apiPlanDatum">{{row.apiPlanDatum | excDate:'Globals.DateFormat' }}</ng-container>
                <ng-container *ngIf="!row.apiPlanDatum">nicht geplant</ng-container>
              </p>
            </div>
            <div class="app-scheduleitem" [class.escalated]="row.apiIsEscalated">
              <p>
                <ng-container
                  *ngIf="row.apiPlanDatum">{{row.apiIstDatum | excDate:'Globals.DateFormat' }}</ng-container>
                <ng-container *ngIf="!row.apiPlanDatum">nicht durchgeführt</ng-container>
              </p>
            </div>
            <div class="span-2">
              <p>{{enumSvc.getEnumerationText(row.au_enmName_AuftragStatus, row.au_enmIdent_AuftragStatus)}}</p>
              <p>{{enumSvc.getEnumerationText(row.vorg_enmName_VorgangStatus, row.vorg_enmIdent_VorgangStatus)}}</p>
            </div>
            <div class="span-2">
              <p>{{row.aueVersicherungsnehmer || '-'}}</p>
              <p>{{row.aueSchadenOrt || '-'}}</p>
            </div>
            <div class="span-2 ">
              <p>{{row.api_OidCKU || '-'}}</p>
              <p>{{row.api_OidCKD | excDate: getGlobal('DateTimeFormatShort')}}</p>
            </div>
            <div class="span-2 ">
              <p>{{row.apiLCU || '-'}}</p>
              <p>{{row.apiLCD | excDate: getGlobal('DateTimeFormatShort')}}</p>
            </div>
          </ng-template>
        </exg-data-table>
        </ng-container>
        <ng-container *ngIf="scheduleTable.newV2Table">
          <exg-table #VCscheduleTableV2
                     (RowDblClick)="scheduleTable.dblClick($event)"
                     (RowChange)="scheduleTable.selectionChanged($event)"
                     (FilterActivation)="scheduleTable.loadData()"
                     [selectKey]="scheduleTable.selectKey"
                     [rowSource]="scheduleTable.data"
                     [tableDef]="scheduleTable.tableDefinition"
                     [distinctTableName]="'ScheduleItems'"
                     [metaInfo]="scheduleTable.MetaInfo"
                     [displayState]="scheduleTable.state"
                     class="content"
                     [allowMultiSelection]="false"
                     [allowSingleSelection]="true"
                     (loadDistinct)="scheduleTable.getDistinctData($event)"
                     [distinctData]="scheduleTable.distinctData">
          </exg-table>
        </ng-container>
      </div>
      <div class="search-quickfilter">
        <i class="search-filter-action fal fa-chevron-right"
           (click)="openReference()"
           [tooltip]="getRessource('openWorkspace')" flow="left"
           [class.disabled]="scheduleTable.isLoading || !scheduleTable.selectedRow">
        </i>
      </div>
      <exg-pager (PageChange)="scheduleTable.pageChanged($event)" *ngIf="!init"
                 [pagingSource]="scheduleTable.paging"
                 class="span-layout">
        <ng-template #leftTemplate>
          <ng-container>
            <app-exg-dropdown class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                              [label]="selectedMod.caption" position="abovecenter" listdisplay="caption"
                              (change)="changePreFilterMod($event.value)">
            </app-exg-dropdown>
            <app-exg-dropdown class="typo-small" [list]="selectedMod.types" elementclass="typo-left" maxHeight="250px"
                              [label]="selectedType.caption" position="abovecenter" listdisplay="caption"
                              (change)="changePreFilterType($event.value)">
            </app-exg-dropdown>
          </ng-container>
        </ng-template>
	      <ng-template #rightTemplate>
		      <div class="app-pager-chips">
			      <app-exg-filter-chips #VCFilterChips
			                            [inputDataTable]="scheduleTable"
			                            [VCFilterControl]="{ VCFilter: VCscheduleTableFilterControl, VCSearch: VCscheduleTableSearchControl, VCSort: VCscheduleTableSortControl}">
			      </app-exg-filter-chips>
		      </div>
	      </ng-template>
      </exg-pager>
    </div>
  </div>
</div>
